export default __webpack_public_path__ + "assets/images/182f68e26c2382d5e141a0e739712c58.png";